import "./PatientInfo.css";
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// 1. 함수 재생성 방지 및 정규식(/g) 적용
const restoreHashMark = (str) => {
    if (!str) return '';
    return String(str).replace(/hashmark/g, '#');
};

function PatientInfo({ param }) { // props 대신 { param } 구조 분해 할당
    const { t } = useTranslation();
    
    // 2. 초기값을 빈 배열 [] 로 깔끔하게 설정
    const [patientInfo, setPatientInfo] = useState([]);

    useEffect(() => {
        const reqOption = {
            method: "POST", // 대문자 컨벤션
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                param: param,
            })
        };

        fetch("/api/getPatientInfo", reqOption)
            .then((response) => response.json())
            .then(data => {
                setPatientInfo(data);
            })
            .catch(err => console.error("Patient Info fetch error:", err)); // 에러 핸들링 추가
    }, [param]);

    // =====================================================================
    // ★ 3. 마법의 헬퍼 함수: Array.every()를 사용해 공통 항목인지 검사합니다.
    // 기존의 복잡한 for문과 6개의 useState를 이 함수 하나로 대체합니다!
    // =====================================================================
    const isCommon = (key) => {
        if (!patientInfo || patientInfo.length === 0) return false;
        const firstValue = patientInfo[0][key];
        // 모든 배열 요소가 첫 번째 값과 똑같은지(every) 검사하여 true/false 반환
        return patientInfo.every(item => item[key] === firstValue);
    };

    // 렌더링 시마다 깔끔하게 계산됩니다. (State가 아니므로 무한 루프 위험 ZERO)
    const commonGender = isCommon('Gender');
    const commonAge = isCommon('Age');
    const commonStage = isCommon('Stage');
    const commonHistologicType = isCommon('HistologicType');
    const commonSmoking = isCommon('smoking');
    const commonTreatmentHistory = isCommon('TreatmentHistory');

    // 첫 번째 환자 데이터를 안전하게 빼둡니다.
    const firstPatient = patientInfo.length > 0 ? patientInfo[0] : {};

    return (
        <div>
            {/* 공통 환자 정보 영역 */}
            <div className="relOrganoid">{t('공통 환자 정보')}</div>
            <div className="commonPatientInfo">
                {commonGender && (
                    <div className="patientBasicInfo">
                        <div className="basicInfoTitle">{t('Gender')}</div>
                        <div className="basicInfoContent">{firstPatient.Gender}</div>
                    </div>
                )}
                {commonAge && (
                    <div className="patientBasicInfo">
                        <div className="basicInfoTitle">{t('Age')}</div>
                        <div className="basicInfoContent">{firstPatient.Age}</div>
                    </div>
                )}
                {commonStage && (
                    <div className="patientBasicInfo">
                        <div className="basicInfoTitle">{t('Stage')}</div>
                        <div className="basicInfoContent">{firstPatient.Stage}</div>
                    </div>
                )}
                {commonHistologicType && (
                    <div className="patientBasicInfo">
                        <div className="basicInfoTitle">{t('Histologic type')}</div>
                        <div className="basicInfoContent">{firstPatient.HistologicType}</div>
                    </div>
                )}
                {commonSmoking && (
                    <div className="patientBasicInfo">
                        <div className="basicInfoTitle">{t('Smoking')}</div>
                        <div className="basicInfoContent">{firstPatient.smoking}</div>
                    </div>
                )}
                {commonTreatmentHistory && (
                    <div className="patientBasicInfo">
                        <div className="basicInfoTitle">{t('Treatment history')}</div>
                        <div className="basicInfoContent">
                            {/* 옵셔널 체이닝(?.)을 사용하여 안전하게 split */}
                            {firstPatient.TreatmentHistory?.split('\n')?.map((str, idx) => (
                                <div key={idx}>{str}</div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            
            {/* 개별 (관련) 오가노이드 영역 */}
            <div className="relOrganoid">{t('관련 오가노이드')}</div>
            {patientInfo.map((item, index) => (
                <div className="relOrganoid" key={`patient-org-${index}`}>
                    <Link to={`/organoid/${item.Key}`} className="relOrganoidName">
                        {restoreHashMark(item.Key)}
                    </Link>
                    <div className="commonPatientInfo">
                        {!commonGender && (
                            <div className="patientBasicInfo">
                                <div className="basicInfoTitle">{t('Gender')}</div>
                                <div className="basicInfoContent">{item.Gender}</div>
                            </div>
                        )}
                        {!commonAge && (
                            <div className="patientBasicInfo">
                                <div className="basicInfoTitle">{t('Age')}</div>
                                <div className="basicInfoContent">{item.Age}</div>
                            </div>
                        )}
                        {!commonStage && (
                            <div className="patientBasicInfo">
                                <div className="basicInfoTitle">{t('Stage')}</div>
                                <div className="basicInfoContent">{item.Stage}</div>
                            </div>
                        )}
                        {!commonHistologicType && (
                            <div className="patientBasicInfo">
                                <div className="basicInfoTitle">{t('Histologic Type')}</div>
                                <div className="basicInfoContent">{item.HistologicType}</div>
                            </div>
                        )}
                        {!commonSmoking && (
                            <div className="patientBasicInfo">
                                <div className="basicInfoTitle">{t('Smoking')}</div>
                                <div className="basicInfoContent">{item.smoking}</div>
                            </div>
                        )}
                        {!commonTreatmentHistory && (
                            <div className="patientBasicInfo">
                                <div className="basicInfoTitle">{t('Treatment History')}</div>
                                <div className="basicInfoContent">
                                    {item.TreatmentHistory?.split('\n')?.map((str, idx) => (
                                        <div key={idx}>{str}</div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default PatientInfo;